import React, { useState, useEffect } from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

import { TypographyCountdown, TypographyCountdownDetail } from '../style/typography';

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);

export default function ReportCountdown(props) {
    const [timeLeft, setTimeLeft] = useState("");
    const [targetReportTime, setTargetReportTime] = useState("");

    useEffect(() => {
        const occuredTime = dayjs(props.occued_at);
        const adjustedTargetTime = occuredTime.add(props.addedMinutes, "minute");

        const updateTimer = () => {
            const now = dayjs();
            const diff = adjustedTargetTime.diff(now, "second");
            let hours, minutes;
            if (diff < 0) {
                const passedDiff = Math.abs(diff);
                hours = String(Math.floor(passedDiff / 3600)).padStart(2, "0");
                minutes = String(Math.floor((passedDiff % 3600) / 60)).padStart(2, "0");
                setTimeLeft(`報告時間が ${hours}時間${minutes}分 過ぎました`);
            } else {
                hours = String(Math.floor(diff / 3600)).padStart(2, "0");
                minutes = String(Math.floor((diff % 3600) / 60)).padStart(2, "0");
                setTimeLeft(`報告時間まであと${hours}時間${minutes}分`);
            }
        };

        setTargetReportTime(adjustedTargetTime.format("YYYY年M月D日 HH:mm"));
        updateTimer();
        const timer = setInterval(updateTimer, 60 * 1000);
        return () => clearInterval(timer);
    }, [props.occued_at]);

  return (
    <Snackbar
    open={true}
    autoHideDuration={null}
    anchorOrigin={{ vertical: "bottom", horizontal: "right" }} >
        <Alert
            severity="error"
            sx={{
            "& .MuiAlert-icon": { display: "none" },
            }}
        >
            <TypographyCountdown>
                {timeLeft}
            </TypographyCountdown>
            <TypographyCountdownDetail>
                報告完了目安:{targetReportTime}
            </TypographyCountdownDetail>
        </Alert>
    </Snackbar>
  );
}